import { UserToFollowerDto } from '@sweatpals/shared';
import { AxiosInstance, AxiosResponse } from 'axios';

export class UsersConnectionService {
	private readonly baseRoute = 'connections';

	constructor(private readonly httpClient: AxiosInstance) {}

	public async follow(userId: string): Promise<AxiosResponse<UserToFollowerDto>> {
		return this.httpClient.post<UserToFollowerDto>(`${this.baseRoute}/${userId}/follow`);
	}
}

export default UsersConnectionService;
